import { getUserAgent } from '../common';

enum WEBP_COMPATIBLE_ENUM {
  LOSSY = 'UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA',
  LOSSLESS = 'UklGRhoAAABXRUJQVlA4TA0AAAAvAAAAEAcQERGIiP4HAA==',
  ALPHA = 'UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAARBxAR/Q9ERP8DAABWUDggGAAAABQBAJ0BKgEAAQAAAP4AAA3AAP7mtQAAAA=='
}

//Fn will check for WebP compatibility on client and set attributes on window object.
//TODO: to be called as soon as user is moved to client side. May be in serve.ts
export const checkWebPCompatible = (isWebPCompatible = false): void => {
  if (isWebPCompatible || window.isWebPCompatible) {
    window.isWebPCompatible = isWebPCompatible || window.isWebPCompatible;
    return;
  }
  const webPImage = new Image();
  webPImage.onload = () => {
    // change "WEBP_COMPATIBLE" flag
    window.isWebPCompatible = webPImage.width > 0 && webPImage.height > 0;
  };
  webPImage.onerror = () => {
    if (getUserAgent().includes('Safari')) {
      window.isWebPCompatible = false;
    }
  };
  webPImage.src = `data:image/webp;base64,${WEBP_COMPATIBLE_ENUM.LOSSLESS}`;
};
